import { Map } from 'immutable';

import { setVideosError } from '../product/errors';

import { ERROR, OPERATIONS, VALUE } from '../../constants/product';
import { ATTRIBUTE } from '../../constants/attributes';
import { FORM } from '../../constants/forms';

export function editVideos({ product: source, value }) {
  let product = source;
  const channel = product.get('channel');

  product = setVideosError({ product: product.setIn([FORM.VIDEOS, VALUE], value) });

  if (product.hasIn([ERROR, ATTRIBUTE.VIDEOS])) return { product, operations: [] };

  return { product, operations: [Map({ type: OPERATIONS[channel].VIDEOS.CHANGE_TO, value })] };
}
